import React from 'react';
import { ViewerContext_UserFragment } from './ViewerContext.generated';

const LoggedInViewerContext = React.createContext<ViewerContext_UserFragment>({
    __typename: 'User',
    id: '',
    displayName: '',
    isAdmin: false,
    isDesigner: false,
    isCertifiedDesigner: false,
    isPartnershipDesigner: false,
    designerLevel: 'ENTRY',
    certifications: [],
});

interface LoggedInViewerProviderProps {
    children: React.ReactNode;
    viewer: ViewerContext_UserFragment;
}

export const LoggedInViewerProvider = ({ children, viewer }: LoggedInViewerProviderProps) => {
    return (
        <LoggedInViewerContext.Provider value={viewer}>{children}</LoggedInViewerContext.Provider>
    );
};

export function useLoggedInViewer(): ViewerContext_UserFragment {
    const context = React.useContext(LoggedInViewerContext);
    if (context === undefined) {
        throw new Error('useLoggedInViewer must be used within a LoggedInViewerProvider');
    }
    return context;
}
